import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { SharedModule } from './shared/shared.module';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { LoginModule } from './features/login/login.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LinkZohoComponent } from './features/link-zoho/link-zoho.component';
import { AvailabilityWidgetComponent } from './features/dashboard/components/availability-widget/availability-widget.component';
import { CallModalComponent } from './features/calls/call-modal/call-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LinkZohoComponent,
    AvailabilityWidgetComponent,
    CallModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    LoginModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    provideHttpClient(withInterceptors([jwtInterceptor]))
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
